import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { Tour } from 'interfaces';

import { AppLocale } from 'constant';
import { LanguageContext } from 'context/languageContext';

import {
  Wrapper,
  List,
  ListItem,
  NumberWrapper,
  Name,
  NameLink,
  TourYearBox,
  TourAreaWrapper,
  AreaWrapper,
  Area,
  DateWrapper,
  RowWrapper
} from './Tours.styles';

export interface ToursProps {
  tours: Tour[];
}

const Tours = ({ tours }: ToursProps) => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <Wrapper>
      <List>
        {
          tours.map((tour, index) => (
            <ListItem key={tour.id}>
              <Name>
                <NumberWrapper>{index + 1}.</NumberWrapper>
                <TourYearBox>
                  {typeof tour.year === 'number' ? tour.year : (tour.year[0])}
                </TourYearBox>
                <NameLink to={`/tours-and-shows/${tour.id}`}>
                  {locale === AppLocale.EN ? tour.englishName || tour.name : tour.name}
                </NameLink>
              </Name>
              <RowWrapper>
                <DateWrapper>
                  <span>
                    {intl.formatMessage({ id: 'tours.duration' })}
                    {intl.formatDateTimeRange(new Date(tour.dateStart), new Date(tour.dateEnd), {
                      year: "numeric",
                      month: "short",
                      day: "numeric"
                    })}
                    {intl.formatMessage({ id: 'tours.numberOfConcerts' }, { number: tour.shows })}
                  </span>
                </DateWrapper>
                <TourAreaWrapper>
                  {intl.formatMessage({ id: 'tours.region' })}
                  <AreaWrapper>
                    {
                      tour.area.map((area) => (
                        <Area area={area} key={area}>
                          {intl.formatMessage({ id: `tours.area.${area}` })}
                        </Area>
                      ))
                    }
                  </AreaWrapper>
                </TourAreaWrapper>
              </RowWrapper>
            </ListItem>
          ))
        }
      </List>
    </Wrapper>
  );
};

export default Tours;
